import React from "react";
import { useLocation } from "react-router";
import Error404Page from "@/src/containers/Pages/Generic/Error404/Error404Page";
import MessageForm from "@/src/components/Messaging/MessageForm/MessageForm";
import { getProductData } from "@/src/services/productService";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import LegalbirdAuthenticatedLoaderPage from "@/src/containers/Pages/Loading/LegalbirdAuthenticatedLoaderPage";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

export default function MessageFormPage() {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const productName = urlSearchParams.get("product") as AbstractCase["name"];
  const productId = urlSearchParams.get("productId");
  const parsedProductId = parseInt(productId || "0");
  const productApiUri = getProductData(productName, "apiUri");

  const { data: product, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, parsedProductId),
    queryFn: () => fetchResource(productApiUri, parsedProductId),
  });

  if (isLoading) {
    return <LegalbirdAuthenticatedLoaderPage />;
  }

  if (!product) {
    return <Error404Page />;
  }

  return (
    <LayoutProtectedRoutes>
      <MessageForm product={product} />
    </LayoutProtectedRoutes>
  );
}
